import { App } from 'antd'
import { useAtom } from 'jotai'
import { useEffect } from 'react'
import { sessionExpiredAtom } from '@/store/auth.atom'

export function SessionExpiredToast() {
  const { notification } = App.useApp()
  const [expired, setExpired] = useAtom(sessionExpiredAtom)

  useEffect(() => {
    if (!expired) return
    notification.error({
      title: 'Phiên đã hết hạn, vui lòng đăng nhập lại.'
    })
    setExpired(false)
  }, [expired, setExpired, notification])

  return null
}